import request from '@/utils/request'

// 소중안 요금제 조회(그리드)
export function getSojunganFeeGridInfo(params, isNotify) {
  return request({
    url: `/api/getSojunganFeeGridInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 소중안 요금제 조회
export function getSojunganFeeDataList(params, isNotify) {
  return request({
    url: `/api/getSojunganFeeDataList`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 소중안 요금제 및 할인정보 조회
export function getSojunganFeePaymentInfo(params, isNotify) {
  return request({
    url: `/api/getSojunganFeePaymentInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
